import { ScrollReveal } from "@/components/ScrollReveal";
import { LOCATIONS, LOCATIONS_IMAGE } from "@/data/content";
import { MapPin, Phone, Clock, Navigation } from "lucide-react";

export const Locations = () => {
  return (
    <section id="locations" className="bg-white py-24 lg:py-32" data-testid="locations-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid lg:grid-cols-[0.7fr_1.3fr] gap-14 items-start">
        <ScrollReveal className="lg:sticky lg:top-32">
          <span className="text-teal text-xs uppercase tracking-[0.3em] font-semibold">
            Our Centres
          </span>
          <h2 className="font-display text-4xl lg:text-5xl text-navy mt-3">
            Four centres. One standard of care.
          </h2>
          <div className="mt-8 overflow-hidden h-64 shadow-[0_20px_50px_rgba(15,31,61,0.1)] group">
            <img
              src={LOCATIONS_IMAGE}
              alt="Swastik Healthcare centre"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms] ease-out"
            />
          </div>
        </ScrollReveal>

        <div className="grid sm:grid-cols-2 gap-6">
          {LOCATIONS.map((loc, i) => (
            <ScrollReveal key={loc.name} delay={i * 0.08} className="h-full">
              <div
                className="group card-lift top-rule relative border border-navy/10 hover:border-teal/30 p-8 h-full flex flex-col bg-bone hover:bg-white hover:shadow-[0_24px_50px_rgba(15,31,61,0.1)]"
                data-testid={`location-card-${i}`}
              >
                <div className="flex flex-col gap-4 flex-1">
                  <h3 className="font-display text-2xl text-navy leading-snug">{loc.name}</h3>
                  <div className="flex items-start gap-3 text-sm text-slate-600">
                    <MapPin size={16} className="text-teal mt-0.5 shrink-0" />
                    <span className="break-words">{loc.address}</span>
                  </div>
                  <a
                    href={`tel:${loc.phone.replace(/\s/g, "")}`}
                    data-testid={`location-phone-${i}`}
                    className="flex items-center gap-3 text-sm text-slate-600 hover:text-teal transition-colors"
                  >
                    <Phone size={16} className="text-teal shrink-0" />
                    {loc.phone}
                  </a>
                  <div className="flex flex-col gap-1">
                    {loc.hours.map((line, hIdx) => (
                      <div key={hIdx} className="flex items-center gap-3 text-sm text-slate-600">
                        <Clock size={16} className="text-teal shrink-0" />
                        {line}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-wrap gap-3 mt-6 pt-2">
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc.mapsQuery)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`location-directions-${i}`}
                    className="flex-1 min-w-[132px] h-11 inline-flex items-center justify-center gap-2 border border-navy text-navy px-3 text-[11px] uppercase tracking-[0.12em] font-medium whitespace-nowrap hover:bg-navy hover:text-white transition-colors duration-300"
                  >
                    <Navigation size={14} /> Get Directions
                  </a>
                  <a
                    href={`tel:${loc.phone.replace(/\s/g, "")}`}
                    data-testid={`location-call-${i}`}
                    className="btn-sheen flex-1 min-w-[132px] h-11 inline-flex items-center justify-center gap-2 bg-teal text-white px-3 text-[11px] uppercase tracking-[0.12em] font-medium whitespace-nowrap hover:bg-navy transition-colors duration-300"
                  >
                    <Phone size={14} /> Call Now
                  </a>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};
